import { ApartmentStatus } from "../const";
import { ApartmentStatusDot } from "./ApartmentStatusDot";
import { cn } from "@/core/helpers/cn";

function Digits({ value, maxDigits }: { value: string; maxDigits: number }) {
  return (
    <div className="top-1/2 left-[16px] absolute font-semibold tabular-nums text-[#323232] text-[28px] text-left tracking-wide -translate-y-1/2">
      {value
        .padEnd(maxDigits, "0")
        .split("")
        .map((char, i) => {
          const isValueChar = i < value.length;

          return (
            // eslint-disable-next-line react/no-array-index-key
            <span key={i} className={isValueChar ? "text-white" : "text-[#323232]"}>
              {char}
            </span>
          );
        })}
    </div>
  );
}

export function DigitDisplay({
  className,
  value,
  maxDigits,
  status,
  size,
}: {
  className?: string;
  value: string;
  maxDigits: number;
  status: ApartmentStatus;
  size: { width: number; height: number };
}) {
  return (
    <div className={cn("relative", className)} style={{ width: size.width, height: size.height }}>
      <Digits value={value} maxDigits={maxDigits} />
      {status !== ApartmentStatus.NotSet && (
        <ApartmentStatusDot status={status} className="absolute top-[38%] right-[15px]" />
      )}
    </div>
  );
}
